import { trigger, transition, style, animate, AnimationTriggerMetadata } from '@angular/animations';

export function registerStackedListItemAnimation(): AnimationTriggerMetadata {
  return trigger('stackedListItem', [
    transition(':enter', [
      style({
        opacity: 0,
        height: '0px',
        transform: 'translateY(50px) scale(0.95)',
      }),
      animate(
        '300ms cubic-bezier(0.25, 1.5, 0.5, 1)',
        style({
          opacity: 1,
          height: '*',
          transform: 'translateY(0) scale(1)',
        }),
      ),
    ]),
    transition(':leave', [
      animate(
        '250ms ease-in',
        style({
          opacity: 0,
          height: '0px',
          transform: 'translateX(+120%) rotate(-7deg)',
          padding: '0px',
          margin: '0 0 -8px 0',
        }),
      ),
    ]),
  ]);
}
